'use client';

import React from 'react';
import { usePathname } from "next/navigation";
import { UEListData } from '@/app/interface/homepage';
import UEHeroCard from '@/app/unlisted-shares/components/ue-hero-card';
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
// import { initBranch, trackEvent } from "@/app/utils/branchio";
import { ButtonSize, ButtonVariant, RegularButton } from '@/stories/button/button';
import { useCleverTapEvents } from '@/app/hooks/use-clevertap';
interface RewardPostKYCSectionProps {
    isUELoading?: boolean;
    data: UEListData[];
    title?: string;
    description?: string;
    referrerEmail?: string;
    userId?: string;
    phone?: string;
    isLoading?: boolean;
}

const RewardPostKYCSection:React.FC<RewardPostKYCSectionProps> = ({isUELoading, data, title, description, referrerEmail, userId, phone, isLoading}) => {
    const pathName = usePathname();
    const { cleverTapTrackEvent } = useCleverTapEvents();

    const exploreUeOpportunities = () => {
        const redirectUrl = `${process.env.ICM_UE_POST_URL_LISTING}` || "/";
            if (pathName && pathName.toLowerCase().indexOf("/refer") !== -1) {
            setAnalyticsEvent(redirectUrl, "US_Rewards_Explore_Unlisted_Shares");
            cleverTapTrackEvent("US_Rewards_Explore_Unlisted_Shares", {});
            window.location.href = redirectUrl;
            // initBranch()
            //     .then(() => {
            //         trackEvent(
            //             "US_Rewards_Explore_Unlisted_Shares",
            //             referrerEmail || "",
            //             phone || "",
            //             userId || "",
            //         );
            //         window.location.href = redirectUrl;
            //     })
            //     .catch((error) => {
            //         console.error("Error initializing Branch:", error);
            //         window.location.href = redirectUrl;
            //     });
        } else {
            window.location.href = redirectUrl;
        }
    };

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center md:gap-[54px] w-full md:w-[910px] mx-auto animate-pulse">
                <div className="flex flex-col items-center justify-center text-center my-8 md:mt-6 md:mb-0 md:my-14 mx-6 md:mx-0 gap-5 w-full">
                    <div className="h-12 md:h-20 w-3/4 md:w-2/3 bg-gray-200 rounded mb-3 md:mb-0" />
                    <div className="h-6 md:h-8 w-2/3 md:w-1/2 bg-gray-100 rounded" />
                </div>
                <div className="w-full md:w-[910px] px-6 grid grid-cols-1 gap-[8px] md:grid-cols-2 md:gap-4">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div
                            key={index}
                            className="bg-white w-[300px] animate-pulse rounded-2xl border-2 border-gray-200 p-4 md:w-[442px] md:p-6"
                        >
                            <div className="flex gap-4">
                                <div className="h-12 w-12 md:h-20 md:w-20 bg-gray-200 rounded" />
                                <div className="flex min-w-0 flex-1 items-center justify-between">
                                    <div className="flex min-w-0 max-w-[calc(100%-40px)] flex-col gap-2">
                                        <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
                                        <div className="h-3 bg-gray-100 rounded w-1/2" />
                                    </div>
                                    <div className="flex-shrink-0 h-8 w-20 bg-gray-100 rounded" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className='w-full md:max-w-max px-6 md:px-0 mt-5 md:mt-0'>
                    <div className="h-12 w-full md:w-60 bg-gray-200 rounded" />
                </div>
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center md:gap-[54px] w-full md:w-[910px] mx-auto">
            <div className="flex flex-col items-center justify-center text-center my-8 md:mt-6 md:mb-0 md:my-14 mx-6 md:mx-0 gap-5">
                <div 
                    className="text-4xl font-semibold leading-[41.6px] md:leading-[67px] tracking-[-0.48px] md:tracking-[-0.56px] text-neutral-900 md:text-7xl max-w-[828px] mx-auto mb-3 md:mb-0"
                    dangerouslySetInnerHTML={{ __html: title || "" }}
                />
                <div 
                    className="text-md leading-[25.6px] md:leading-[32px] tracking-[-0.2px] text-neutral-500 md:text-xl md:max-w-[872px] mx-auto"
                    dangerouslySetInnerHTML={{ __html: description || "" }}
                />
            </div>
            <div className="w-full md:w-[910px] px-6 grid grid-cols-1 gap-[8px] md:grid-cols-2 md:gap-4">
                {isUELoading
                    ? Array.from({ length: 4 }).map((_, index) => (
                          <div
                              key={index}
                              className="bg-red w-[300px] animate-pulse rounded-2xl border-2 border-gray-200 p-4 md:w-[442px] md:p-6"
                          >
                              <div className="flex gap-4 bg-gray-200">
                                  {/* Image container with fixed dimensions */}
                                  <div className="h-12 w-12 flex-shrink-0 md:h-20 md:w-20"></div>

                                  {/* Content wrapper with proper flex behavior */}
                                  <div className="flex min-w-0 flex-1 items-center justify-between">
                                      {/* Text content with proper truncation */}
                                      <div className="flex min-w-0 max-w-[calc(100%-40px)] flex-col gap-2">
                                          <div className="overflow-hidden">
                                              <h3 className="truncate text-sm font-semibold md:text-lg"></h3>
                                          </div>
                                          <div className="whitespace-nowrap text-sm">
                                              <span className="text-gray-400"></span>
                                          </div>
                                      </div>

                                      {/* Button with fixed width */}
                                      <div className="flex-shrink-0"></div>
                                  </div>
                              </div>
                          </div>
                      ))
                    : data?.map((card: UEListData, index: number) => (
                        <UEHeroCard key={index} {...card} refEvent={`US_Rewards_${card.product}`} email={referrerEmail} userId={userId} phone={phone}/>
                ))}
            </div>
            <div className='w-full md:max-w-max px-6 md:px-0'>
                <RegularButton
                    noIcon
                    showRightIcon={false}
                    size={ButtonSize.Large}
                    variant={ButtonVariant.PrimaryDefault}
                    className="mt-5 w-full max-w-full md:mt-0 md:w-auto"
                    label="Explore Unlisted Shares"
                    onClick={() => exploreUeOpportunities()}
                />
            </div>
        </div>
    );
}

export default RewardPostKYCSection